import { BillingForm } from '../../../billing/BillingForm';

export interface AddCreditCardSectionProps {
  customerServicePhone: string;
  customerServiceEmail: string;
  onClose: () => void;
}

export function AddCreditCardSection({
  customerServicePhone,
  onClose,
}: AddCreditCardSectionProps) {
  return (
    <div className="add-credit-card-section">
      <BillingForm customerServicePhone={customerServicePhone} onClose={onClose} inline />
    </div>
  );
}
